import * as styles from './EventHead.css';
import { safeFormatDateTime } from '@/utils/dateUtils.ts';
import { useEventInfo } from '@/features/apply-event/hooks/useEvent';
import useApplyEventId from '../../hooks/useApplyEventId';

const EventHead = () => {
  const eventId = useApplyEventId();
  const eventInfo = useEventInfo(eventId);

  const title = eventInfo?.title ?? 'ixi-O 신규가입 이벤트';
  const startTime = eventInfo?.startTime ?? '2025-04-28T06:18:00.000Z';

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.label}>{safeFormatDateTime(startTime)}</p>
    </div>
  );
};

export default EventHead;
